const checkIfStoreIsFilled = async store => {
  const { localizacao_unidades } = store.state

  if (localizacao_unidades.unidades.length === 0) {
    await store.dispatch('fetchLocalizacaoUnidades', 'SMS')
  }
}

export const latLong = async (nomeUnidade, store) => {
  await checkIfStoreIsFilled(store)

  const { localizacao_unidades } = store.state

  const finder = latitude => latitude.nome_mv === nomeUnidade
  const unidade = localizacao_unidades.unidades.find(finder)

  if (unidade) {
    const { lat, lng } = unidade.position
    return {
      nome: unidade.nome_mv,
      lat,
      lng
    }
  }

  return {
    nome: 'santos-default',
    lat: -23.857523739574418,
    lng: -46.293318312076764
  }
}

export const latLongGroup = async (unidades, store) => {
  await checkIfStoreIsFilled(store)

  const { localizacao_unidades } = store.state

  const filter = coordenada =>
    unidades.find(({ unidade_saude }) => unidade_saude === coordenada.nome_mv)

  return localizacao_unidades.unidades
    .filter(filter)
    .map(({ position, nome_mv: title }) => {
      const { disponivel: available } = unidades.find(
        unidade => unidade.unidade_saude === title
      )

      const { lat, lng } = position
      return {
        position: {
          lat,
          lng
        },
        title,
        available
      }
    })
}



// WEBPACK FOOTER //
// ./src/utils/coordenadas-remedios.js